import AssessmentCreationForm from "pages/ManagementPage/AssessmentCreationForm/AssessmentCreationForm";

export default AssessmentCreationForm;
